import type { Component } from "solid-js";
import { Button } from "@/components/ui/button";
import { useNavigate } from "@/lib/u-router";

interface SettingsRowButtonProps {
  label: string;
  to: string;
  icon: Component<{ class?: string }>;
}

export function SettingsRowButton(props: SettingsRowButtonProps) {
  const navigate = useNavigate();
  return (
    <Button
      variant="outline"
      class="w-full justify-between rounded-xl border border-accent/25 bg-muted/20 h-10 select-none cursor-pointer"
      onClick={() => void navigate({ to: props.to })}
    >
      <div class="flex items-center gap-3">
        <props.icon class="h-4 w-4 text-muted-foreground" />
        <span>{props.label}</span>
      </div>
      <span class="text-muted-foreground text-xs">→</span>
    </Button>
  );
}
